import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {EntitlementGrantLogsCriteria} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';


export const entitlementGrantChangeLogStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementGrantLogsCriteria
>('entitlementGrantChangeLogState', undefined);

export const entitlementGrantChangeLogStateActions = entitlementGrantChangeLogStateSlice.actions;
export const entitlementGrantChangeLogStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    EntitlementGrantLogsCriteria
> = state => state.manageEntitlements.entitlementGrantChangeLogReducer.state;
